import { ErrorMessage, useFormikContext } from "formik";
import BsForm from "react-bootstrap/Form";
import { SealRegistrationFormData } from "../SealRegistrationContext";

export const CommunicationPreferencesSection = () => {
  const { values, setFieldValue } = useFormikContext<SealRegistrationFormData>();

  return (
    <div className="seal-form-section seal-form-section--bordered">
      <h2 className="sub-headline">Communication preferences</h2>

      <p className="description-text">
        OVR will use the applicant's contact information to administer the
        registration and license. This includes registration updates, questions
        about vineyard information, approval materials, changes to the Usage
        Guidelines or License Terms, compliance questions, and other notices
        necessary to operate the OVR Seal program.
      </p>

      <BsForm.Check
        className="checkbox-label-text"
        checked={values.communicationsRequired}
        onChange={() =>
          setFieldValue(
            "communicationsRequired",
            !values.communicationsRequired
          )
        }
        label="I understand that OVR will send me communications necessary to administer this registration and the ongoing use of the OVR Seal."
      />
      <ErrorMessage
        name="communicationsRequired"
        className="input-error"
        component="span"
      />

      <BsForm.Check
        className="checkbox-label-text"
        style={{ marginTop: "16px" }}
        checked={values.communicationsOptional}
        onChange={() =>
          setFieldValue(
            "communicationsOptional",
            !values.communicationsOptional
          )
        }
        label="Yes, I would also like to receive occasional OVR news, program announcements, educational content, event information, and opportunities to support the Old Vine Registry by email."
      />
      <span className="form-fields-sub-text" style={{ marginLeft: "30px" }}>
        This is optional and does not affect registration. You may withdraw your
        consent at any time using the unsubscribe link in these emails. See the{" "}
        <a href="/privacy" className="form-fields-sub-text-link">
          Privacy Policy
        </a>{" "}
        for details.
      </span>

      <p
        className="form-fields-sub-text"
        style={{ borderTop: "1px solid #ddd", paddingTop: "14px", marginTop: "16px" }}
      >
        The Old Vine Registry will process the information submitted in this form
        to review and administer the registration, manage participation in the
        OVR Seal program, communicate about authorized use, and maintain
        appropriate program records.{" "}
        <a href="/privacy" className="form-fields-sub-text-link">
          Learn how OVR handles personal information in the Privacy Policy
        </a>
        .
      </p>
    </div>
  );
};
